/* eslint-disable no-plusplus */
/* eslint-disable global-require */
const GTM = require('../datalayer');

const handleSecondStepInfo = () => {
    const checkoutDatalayerStep = window.dataLayer.filter(
        obj => obj.event === 'begin_checkout',
    );
    const shippingSelected = $('.shipping-method-block input:checked');
    if (checkoutDatalayerStep.length > 0 && shippingSelected.length > 0) {
        GTM.trackCheckoutStep(
            {
                shipping_tier: $('.shipping-method-block input:checked')[0].value,
                items: checkoutDatalayerStep[0].ecommerce.items,
            },
            'add_shipping_info',
        );
    }
};

const infoFirstStepCheckout = () => {
    const url = $('.checkoutDatalayer')[0].value;

    $.ajax({
        url,
        type: 'GET',
        dataType: 'json',
        success(data) {
            GTM.trackCheckoutStep({ items: data.allProducts }, 'begin_checkout');

            if (
                (data.selectedShippingMethod && $('.payment-form').css('display') === 'block')
                || (data.selectedShippingMethod && $('.payment-summary').css('display') === 'block')
            ) {
                handleSecondStepInfo();
            }
        },
        error(err) {
            console.log('datalayer error', err, err.responseText);
        },
    });
};

const infoSecondStepCheckout = () => {
    $('button.submit-shipping').on('click', () => {
        handleSecondStepInfo();
    });
};

const infoThirdStepCheckout = () => {
    $('body').on('click', 'li.method-wrapper', () => {
        const checkoutDatalayerStep = window.dataLayer.filter(
            obj => obj.event === 'begin_checkout',
        );
        if (checkoutDatalayerStep.length > 0) {
            setTimeout(() => {
                GTM.trackCheckoutStep(
                    {
                        payment_type: $('.nav-item > a.active')
                            .parent()
                            .data('method-id'),
                        items: checkoutDatalayerStep[0].ecommerce.items,
                    },
                    'add_payment_info',
                );
            }, 500);
        }
    });
};

const selectShippingMethodOption = () => {
    let selectedOption = {};
    if ($('.form-check-input').length) {
        $('body').on('change', 'input.form-check-input', (e) => {
            selectedOption = {
                elementTarget: $(e.currentTarget)[0].value,
                labelText: $(e.target)
                    .parent()
                    .find('label')[0].innerText,
            };

            GTM.trackEventOption('click', selectedOption);
        });
    }
};

$(document).ready(() => {
    infoFirstStepCheckout();
    infoSecondStepCheckout();
    infoThirdStepCheckout();
    selectShippingMethodOption();
});
